import * as React from 'react';
import { styled } from '@mui/material/styles';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
//import Typography from '@mui/material/Typography';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuContent from './MenuContent';
import Copyright from '../internals/components/Copyright';
import { Link } from 'react-router-dom';

const drawerWidthExpanded = 220;
const drawerWidthCollapsed = 64;

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'isCollapsed',
})(({ theme, isCollapsed }) => ({
    width: isCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    [`& .${drawerClasses.paper}`]: {
        width: isCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
        transition: theme.transitions.create(['width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
        boxSizing: 'border-box',
        // borderRadius: '16px',  // Border radius
        borderRight: '1px solid rgba(224, 224, 224, 0.50)',  // Right border style
        background: 'linear-gradient(to bottom, #bcf1ff, #95cde4, #71aaca, #5287af, #396594, #436194, #4d5c92, #57578f, #7e6ea8, #a485c1, #cc9ed9, #f4b8f1)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backdropFilter: 'blur(12px)'
    },
}));

export default function ResponsiveSidebar() {
    const [isCollapsed, setIsCollapsed] = React.useState(false);

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <Drawer variant="permanent" isCollapsed={isCollapsed}>
            {/* Logo and Toggle Button */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: isCollapsed ? 'left' : 'left',
                    p: 2,
                    flexDirection: 'row',
                    //backgroundColor: '#1a1642',
                }}
            >
                <Link to="/home" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                    {isCollapsed &&
                        <Stack  direction="column" justifyContent="center">
                            <img
                                src="/assets/images/healthcare/kyol_logo_small.png"
                                alt="KeyInsight Data Logo"
                                style={{ justifyContent: isCollapsed ? 'left' : 'left', height: '32px' }}
                            />
                        </Stack>
                    }
                    {!isCollapsed && (
                        <Stack  direction="column" justifyContent="center">
                            <img
                                src="/assets/images/healthcare/oncoInsight_logo_mini.png"
                                alt="KeyInsight Data Logo"
                                style={{ justifyContent: isCollapsed ? 'left' : 'left', width: '187' }}
                            />
                        </Stack>
                    )}
                </Link>


            </Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'left',
                justifyContent: isCollapsed ? 'right' : 'right',
                //pr: 2.5,
                flexDirection: 'row', mb: 1,
            }}>
                <IconButton
                    onClick={toggleSidebar}
                    sx={{ transition: 'all 0.3s', borderRadius: '50px', height: '24px', width: '24px', border:0, bgcolor: 'rgba(255,255,255,0.01)', }}
                >
                    {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            </Box>
            <Divider />

            {/* Menu Items */}
            <MenuContent isCollapsed={isCollapsed} />

            {/* Footer */}
            <Stack
                sx={{
                    p: 1,
                    pl: 2,
                    justifyContent: 'center',
                    alignItems: isCollapsed ? 'center' : 'flex-start',
                }}
            >
                {!isCollapsed && (
                    <Copyright
                        sx={{
                            textAlign: 'center',
                            fontSize: '0.8rem',
                            display: 'block',
                        }}
                    />
                )}
            </Stack>
        </Drawer >
    );
}